__turbopack_context__.v({
  "hidden": "PixelReveal-module__HnYPvq__hidden",
});
